import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import "./SuperstarGreetingsForm.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ReactPlayer from "react-player";
import useFileHandleS3 from "../../../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../../../../CustomHooks/useVideoHandleWithCompress";

const SuperstarGreetingsForm = () => {
  const history = useHistory();
  const [convertedContent, setConvertedContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    title: "",
    cost: "",
    user_required_day: "",
    // stars: [],
    error_list: [],
  });

  // File Handle Banner
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'greetings/images', delKey);

  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'greetings/videos', videoDelKey);

  const handleInput = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  // Banner
  const bannerHandler = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  // Video
  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const greetingSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();
    fData.append("banner", fileKey);
    fData.append("video", videoKey);
    fData.append("star", inputData.star);
    fData.append("title", inputData.title);
    fData.append("cost", inputData.cost);
    fData.append("share_cost", inputData.share_cost);
    fData.append("user_required_day", inputData.user_required_day);
    fData.append("instruction", convertedContent);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/add_greetings`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push(`/superstar/greetings`);
        } else if (res.data.status === 422) {
          setInputData({
            ...inputData,
            error_list: res.data.validation_errors,
          });
        } else {
          // swal("Error", res.data.message, "error");
        }
      });
    });
  };

  return (
    <>
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">
          Create greetings profile for you
        </h4>
      </div>
      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  onSubmit={greetingSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        placeholder="Enter title"
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="title"
                        value={inputData.title}
                      />
                      <span className="text-danger">
                        {inputData.error_list.title}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Instruction</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        data={convertedContent}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {inputData.error_list.instruction}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Cost</p>
                    </div>
                    <div className="col-md-3">
                      <input
                        className="form-control reply-control"
                        type="number"
                        placeholder="Enter fee $"
                        onChange={handleInput}
                        name="cost"
                        value={inputData.cost}
                      />
                      <span className="text-danger">
                        {inputData.error_list.cost}
                      </span>
                    </div>

                    <div className="col-md-3 label-text text-md-end">
                      <p>Share Cost</p>
                    </div>
                    <div className="col-md-3">
                      <input
                        className="form-control reply-control"
                        type="number"
                        placeholder="Enter share fee $"
                        onChange={handleInput}
                        name="share_cost"
                        value={inputData.share_cost}
                      />
                      <span className="text-danger">
                        {inputData.error_list.share_cost}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Required day before date</p>
                    </div>
                    <div className="col-md-3">
                      <input
                        placeholder="Enter day"
                        className="form-control reply-control"
                        type="number"
                        onChange={handleInput}
                        name="user_required_day"
                        value={inputData.user_required_day}
                      />
                      <span className="text-danger">
                        {inputData.error_list.user_required_day}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Upload Banner</p>
                    </div>
                    <div className="col-md-9">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src mb-3"
                          alt=""
                        />
                      ) : (
                        <></>
                      )}
                      <input
                        type="file"
                        accept="image/jpg,image/jpeg, image/png"
                        className="inputfile"
                        onChange={(e) => bannerHandler(e.target.files)}
                        id="image"
                        name="image"
                      />
                      {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <label for="image">
                        <i className="fas fa-cloud-upload-alt"></i> Upload
                      </label>
                      <span className="text-danger">
                        {inputData.error_list.banner}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Upload Video</p>
                    </div>
                    <div className="col-md-9">
                      {videoUrl ? (
                        <>
                          <ReactPlayer
                            url={videoUrl}
                            // width="100%"
                            controls={true}
                            height="35vh"
                          />
                        </>
                      ) : (
                        <></>
                      )}

                      <input
                        type="file"
                        name="video"
                        id="video"
                        accept="video/mp4"
                        className="inputfile"
                        onChange={(e) => handleVideoChange(e.target.files)}
                      />
                      {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                      <label for="video">
                        <i className="fas fa-cloud-upload-alt"></i> Upload
                      </label>
                      <span className="text-danger">
                        {inputData.error_list.video}
                      </span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperstarGreetingsForm;
